// Auth Routes
const Home = () => import('@/views/Home').then(m => m.default || m)
const About = () => import('@/views/About').then(m => m.default || m)
const WhoWeAre = () => import('@/views/WhoWeAre').then(m => m.default || m)
const WhatWeDo = () => import('@/views/WhatWeDo').then(m => m.default || m)
const ContactUs = () => import('@/views/ContactUs').then(m => m.default || m)

export default [
  { path: '/', name: 'home', component: Home },
  { path: '/about-us', name: 'about', component: About },
  { path: '/who-we-are', name: 'whoWeAre', component: WhoWeAre },
  { path: '/what-we-do', name: 'whatWeDo', component: WhatWeDo },
  { path: '/contact-us', name: 'contact', component: ContactUs },
]


// WEBPACK FOOTER //
// ./src/router/routes.js